<template>
  <div>
    <el-button
      type="text"
      size="mini"
      icon="fas fa-cog"
      @click="$refs.editScaleDialog.open({scale: data})"
    >
      {{ scopesEditDisabled ? 'Смотреть' : 'Настроить' }}
    </el-button>
    <card-element-configurable-scale-edit-dialog
      ref="editScaleDialog"
      :disabled="scopesEditDisabled"
      @close="$emit('elements-changed');"
    >
    </card-element-configurable-scale-edit-dialog>
  </div>
</template>

<script>
import CardElementConfigurableScaleEditDialog from "@/components/configurableScales/settings/CardElementConfigurableScaleEditDialog.vue";
import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "quality-card-plan-view",
  mixins: [dynamicScaleComponent],
  components: {CardElementConfigurableScaleEditDialog, ClickToEdit},
  props: {
    disabled:{type: Boolean, default: false},
    row:{type: Object},
  },
  computed: {
    scopesEditDisabled() {
      if (this.disabled) {
        return true;
      }
      if (!this.data?.template?.allow_scopes_edit_in_element) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      scale:{
        plan: null,
      },
    }
  },
  methods: {}
}
</script>